import TextTooltip from 'components/molecules/TextToolTip'
import { SummaryCard } from './styles'
import { UnitForm } from '../../constants'

export interface SectionSummaryCardProps {
  Description: string
  FirmId: number
  IsDisabled: boolean
  Name: string
  Order: number
  QuestionId: number
  QuestionSectionId: number
  QuestionSummary: string
  QuestionTypeId: number
  QuestionVersionId: number
  UnitForm: UnitForm
  Value: string
  handleClick: (questionId: number) => void
}

const QuestionnaireSectionSummaryCard = (
  props: SectionSummaryCardProps
): JSX.Element => {
  const {
    IsDisabled,
    Name,
    QuestionSummary,
    QuestionId,
    handleClick,
    UnitForm
  } = props

  return (
    <>
      {!IsDisabled && (
        <SummaryCard>
          <div
            className='summary-card'
            onClick={() => handleClick(QuestionId)}
            style={{ cursor: 'pointer' }}
          >
            {UnitForm.QuestionCompleteFlag && (
              <div className='mdi mdi-check-circle-outline complete' />
            )}
            {!UnitForm.QuestionCompleteFlag && (
              <div className='mdi mdi-check-circle-outline' />
            )}

            <div className='question-description'>
              <div className='question-name' data-testid='question-name'>
                {Name}
              </div>
              <TextTooltip text={QuestionSummary}></TextTooltip>
            </div>
            <div className='mdi mdi-chevron-right' />
          </div>
        </SummaryCard>
      )}
    </>
  )
}

export default QuestionnaireSectionSummaryCard
